// Response envelopes (04 §2.3).
import { z } from 'zod';
import { errorCodeSchema } from './errors.js';

export const apiMetaSchema = z.object({
  serverTime: z.iso.datetime(), // lets clients correct clock skew
  requestId: z.uuid(),
});

export const apiSuccess = <T extends z.ZodType>(data: T) =>
  z.object({ success: z.literal(true), data, meta: apiMetaSchema });

export const apiErrorSchema = z.object({
  code: errorCodeSchema,
  message: z.string(), // safe to show in a toast
  details: z.record(z.string(), z.unknown()).optional(),
  requestId: z.uuid(),
});
export type ApiError = z.infer<typeof apiErrorSchema>;

export const apiFailureSchema = z.object({ success: z.literal(false), error: apiErrorSchema });

/** Cursor pagination: `?limit=50&cursor=…` (default 50, max 200). */
export const paginated = <T extends z.ZodType>(item: T) =>
  z.object({ items: z.array(item), nextCursor: z.string().nullable() });

export const PAGE_LIMIT_DEFAULT = 50;
export const PAGE_LIMIT_MAX = 200;
